import { Card, CardContent, CardFooter } from "@/_old/components/ui/card";
import { Skeleton } from "@/_old/components/ui/skeleton";
import { CarouselInsightsSkeleton } from "@/core/components/layout/carousel-insights/components/carousel-insights-skeleton";

export function InsightsCardsConsumptionSkeleton({
  carousel = false,
}: {
  carousel?: boolean;
}) {
  return carousel ? (
    <CarouselInsightsSkeleton />
  ) : (
    <Card className="p-6 w-full max-w-md">
      <CardContent className="p-0 space-y-4">
        <div className="flex justify-between items-start">
          <Skeleton className="w-6 h-5 rounded-md" />

          <Skeleton className="w-24 h-5 rounded-full" />
        </div>

        <div className="space-y-3">
          <Skeleton className="w-full h-6" />
          <Skeleton className="w-3/4 h-6" />

          <Skeleton className="w-48 h-5" />

          <Skeleton className="w-full h-5" />
        </div>
      </CardContent>

      <CardFooter className="p-0 pt-6">
        <Skeleton className="w-full h-6 rounded-md" />
      </CardFooter>
    </Card>
  );
}
